import type { Customization } from '../types/customization';
import type { Dish } from '../types/dish';
import type { MenuOption } from '../types/cukcukImport';
import { resolveOptionCatalog } from './cukcukInvoiceImportUtils';

export const buildFullOptionCatalog = (
  customizations: Customization[],
  dishes: Dish[],
  menuOptions: MenuOption[] = [],
): MenuOption[] =>
  resolveOptionCatalog({
    customizations,
    dishes,
    menuOptions,
  });